import {WorkspaceStatesConstant} from '@/branchmanager/app/constant/WorkspaceStatesConstant'
import {FeatureCodes} from '@/branchmanager/app/enums/featureCodesEnum'
import '@banno/jha-wc/src/icons/jha-icon-dashboard.js'
import '@banno/jha-wc/src/icons/jha-icon-fi.js'

export interface Site {
  route: string
  name: string
  icon: string
  featureCode: string
}

export const openAnywhereSites: Site[] = [
  {
    route: WorkspaceStatesConstant.DESKTOP.STATE,
    name: 'Workspace',
    icon: "<jha-icon-fi class='nav-icon'/>",
    featureCode: FeatureCodes.WORKSPACE
  },
  {
    route: WorkspaceStatesConstant.DASHBOARD.STATE,
    name: 'Dashboard',
    icon: "<jha-icon-dashboard class='nav-icon'/>",
    featureCode: FeatureCodes.DASHBOARD
  }
]
